import { GET_TRAVEL_ITEM } from "../actions/types";

const initialState = {
  travelItems: [],
};

const travelItemReducer = (state = initialState, action) => {
  const type = action.type;
  switch (type) {
    case GET_TRAVEL_ITEM:
      return {
        ...state,
        travelItems: action.payload,
      };
    default:
      return state;
  }
};

export default travelItemReducer;
